export const SUBSCRIPTION_WIDGET_USE_CASE_NOT_SET = 'not-set';
export const SUBSCRIPTION_WIDGET_USE_CASE_DEFAULT = 'default';

export const SUBSCRIPTION_PROMPT_WIDGET_DEFAULT_CONFIG = {
  headerText: 'Subscribe to our news',
  headerTextColor: '#000000',
  subheaderText: 'Don\'t miss out on the latest news and updates!',
  subheaderTextColor: '#000000',
  buttonAcceptText: 'Agree',
  buttonAcceptTextColor: '#1A72E8',
  buttonAcceptRound: '4px',
  buttonAcceptBackgroundColor: '#FFFFFF',
  buttonAcceptBorderColor: '#E3E4E8',
  buttonCancelText: 'Deny',
  buttonCancelTextColor: '#1A72E8',
  buttonCancelRound: '4px',
  buttonCancelBackgroundColor: '#FFFFFF',
  buttonCancelBorderColor: '#E3E4E8',
  cappingCount: 3,
  cappingDelay: 1000 * 60 * 60 * 4, // time in ms
  backgroundColor: '#FFFFFF',
};
